export * from './email-verification-failed-page.component';
